export default [
    {
        id: 'calendar',
        title: 'Сургалтын хуанли',
        icon: <i className="far fa-calendar-alt"></i>,
        navLink: "/calendar",
    }
]
